import { css } from '@emotion/react'
import { Color, Theme, Typography } from '@opallabs/gem'

export const rootClass = 'lapidary-single-select-trigger-text'

export const selectionText = ({
  theme,
  isPlaceholder,
}: {
  theme: Theme
  isPlaceholder: boolean
}) =>
  css({
    ...Typography.T500,
    color: isPlaceholder ? Color[theme].Text.Gray : Color[theme].Text.Default,
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&[aria-invalid="true"]': {
      opacity: 0.5,
    },
  })
